'use strict';exports.__esModule = true;var _constants = require('../constants');
















var getModifier = function getModifier(type) {
  switch (type) {
    case _constants.imageModifierTypes.LOGO:return _constants.companyLogoAspectFitModifier;
    case _constants.imageModifierTypes.THUMBNAIL:return _constants.thumbnailModifier;
    case _constants.imageModifierTypes.PROJECT_THUMBNAIL:return _constants.projectThumbnailModifier;
    case _constants.imageModifierTypes.PROJECT_DETAILS:return _constants.projectDetailsModifier;
    case _constants.imageModifierTypes.SLIDER_THUMBNAIL:return _constants.sliderThumbnailModifier;
    case _constants.imageModifierTypes.PROFESSIONALS_SLIDER:return _constants.professionalsSliderModifier;
    case _constants.imageModifierTypes.PORTFOLIO_THUMBNAIL:return _constants.portfolioThumbnailModifier;
    case _constants.imageModifierTypes.PROPERTY_THUMBNAIL:return _constants.propertyModifier;
    case _constants.imageModifierTypes.GALLERY_THUMBNAIL:return _constants.galleryModifier;
    case _constants.imageModifierTypes.GALLERY_THUMBNAIL_MOBILE:return _constants.galleryModifierMobile;
    default:return _constants.thumbnailModifier;}

};

var modifyImageLink = function modifyImageLink(imageLink) {var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.imageModifierTypes.THUMBNAIL;
  if (!imageLink || typeof imageLink !== 'string') {
    return '';
  }

  if (!imageLink.startsWith(_constants.CLOUDINARY_BASE_URL)) {
    return imageLink;
  }

  var modifier = getModifier(type);

  var arrayFromImageLink = imageLink.split('/');

  var publicId = arrayFromImageLink[arrayFromImageLink.length - 1];

  var imageParams = arrayFromImageLink[arrayFromImageLink.length - 2];
  var imageParamsArray = imageParams.split(',');
  var angleParam = imageParamsArray.filter(function (item) {return item.indexOf('a_') === 0;});
  var angle = angleParam.length ? +angleParam[0].split('_').pop() : 0;
  var anglePart = !!angle ? ',a_' + angle : '';

  return (0, _constants.getAssetsBaseUrl)(_constants.cloudinaryContentTypes.IMAGE) + '/' + modifier + anglePart + '/' + publicId;
};exports.default =

modifyImageLink;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/modifyImageLink.js
// module id = 41
// module chunks = 0